import { mapState, mapActions } from 'vuex'

// 任意のサービスに登録されたRSSから選択するUIモジュール
// ●使用箇所
// 「サービス管理-コンテンツ設定-画面別設定-画面別コンテンツ編集」
export default {
  name: 'ServiceRssSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceRssModal.buttonId,
      modalIndex: state => state.selectServiceRssModal.index,
      value: state => state.selectServiceRssModal.value,

      // model
      serviceRssModel: state => state.selectServiceRssModal.serviceRssModel,
    }),

    results () {
      if (this.loading) return ''

      // RSS名を取得
      try {
        return this.serviceRssModel.filter(item => this.model.indexOf(item.serviceRssUuid) !== -1)
          .map(item => item.rssName).join('、')
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // showDeleteButton () {
    //   return this.model ? true : false
    // }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeValue(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'selectServiceRssModal/loadModel',
      showModal: 'selectServiceRssModal/show',
      setValue: 'selectServiceRssModal/setValue'
    }),

    init () {
      // 初期データを格納
      this.setValue(this.model)

      // RSS取得のためデータ読出
      this.loading = true

      //
      let serviceRssParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceRssParams: serviceRssParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showSelector () {
      this.showModal({
        serviceId: this.serviceId,
        buttonId: this.name,
        index: this.index,
        data: this.model
      })
    },

    changeValue (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    // deleteScreen () {
    //   this.$emit('childs-delete', {
    //     name: this.name,
    //     index: this.index
    //   })
    // }
  }
}